module.exports = __webpack_public_path__ + "img/tik.a4ff529f.png";